import { render } from "./mped-spr-fed-subject-view.vue?vue&type=template&id=0be94d7e"
import script from "./mped-spr-fed-subject-view.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-spr-fed-subject-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/vbSprFedSubject/mped-spr-fed-subject-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0be94d7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0be94d7e', __exports__)) {
    api.reload('0be94d7e', __exports__)
  }
  
  module.hot.accept("./mped-spr-fed-subject-view.vue?vue&type=template&id=0be94d7e", () => {
    api.rerender('0be94d7e', render)
  })

}


export default __exports__